// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/5p-check.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/5p-check/5p-check.js';

mount([g0]);
